import { appendAPExamTemplate } from '@/functions/idp'
import RIC from './RIC_13'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
